import { CSSProperties } from 'react';
import styled from 'styled-components';

const HSMSI = styled.i`
  &#hsms-icon {
    font-size: 18px;
  }
`;

export interface HSMSIconProps {
  name: string;
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  title?: string;
}

export const HSMSIcon = ({ className, name, onClick, style, title }: HSMSIconProps) => {
  return (
    <HSMSI
      style={style}
      id="hsms-icon"
      className={`material-icons hsms-icon ${className}`}
      onClick={onClick}
      title={title}
    >
      {name}
    </HSMSI>
  );
};
